import { Controller } from "@hotwired/stimulus"

// Opens the print-friendly variant of the current admin page in a new tab,
// with ?auto_print=1 so it triggers the browser print dialog once charts
// have rendered. The print page uses its own layout (no sidebar/topbar/
// filter bar) and is sized for landscape A4. See:
//   - app/views/layouts/admin_print.html.erb
//   - app/views/admin/analytics/dashboard/print.html.erb
//
// `data-print-report-href-value` on the button overrides the default
// (current path + "/print") if the print route lives elsewhere.
export default class extends Controller {
  static values = { href: String }

  print() {
    const url = new URL(window.location.href)
    if (this.hasHrefValue && this.hrefValue) {
      const next = new URL(this.hrefValue, window.location.origin)
      // Carry over current filter params (region_ids[], date_range, etc.)
      url.searchParams.forEach((v, k) => next.searchParams.append(k, v))
      next.searchParams.set("auto_print", "1")
      window.open(next.toString(), "_blank", "noopener")
      return
    }

    // Default: same path + "/print" (e.g. /admin/analytics → /admin/analytics/print)
    url.pathname = url.pathname.replace(/\/?$/, "") + "/print"
    url.searchParams.set("auto_print", "1")
    window.open(url.toString(), "_blank", "noopener")
  }
}
